import apiUrl from '../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import {
	Validator
} from 'vee-validate'
import DatePicker from 'vue2-datepicker'
import CryptoJS from 'crypto-js';
import moment from 'moment'
import {
	BasicSelect
} from 'vue-search-select'
import VueElementLoading from 'vue-element-loading';

export default {
	name: 'creategroup',
	components: {
		Paginate,
		BasicSelect,
		VueElementLoading
	},
	data: function() {
		return {

			searchFlag: false,
			validateFlag: false,
			bagstatus: '',
			bagno: '',
			isLoading: false,
			bagStatusObjData: {
				value: "",
				text: ""
			},
			bagStatusData: [{
					value: '1',
					text: "Invalid"
				},
				{
					value: '2',
					text: "Outscan"
				},

			],

		}
	},

	created: function() {},
	computed: {},

	mounted() {

		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.useremail = userdetail[0].email;

	},
	methods: {

		selectedbagStatus(bagData) {
			//console.log(bagData);
			this.bagStatusObjData = bagData;
			this.bagstatus = this.bagStatusObjData.value;
		},

		markBagInvalid() {
			this.isLoading = true;
			this.input = ({
				BagNo: this.bagno,
				LastModifiedBy: this.useremail,
			})

			axios({
					method: 'POST',
					'url': apiUrl.api_url_hubops + 'markBagsInValid',
					'data': this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
					}
				})
				.then((result) => {
					this.isLoading = false;

					if (result.data.ResultCode == 101) {
						this.$alertify.error(result.data.ReturnMessage);
					}
					if (result.data.ResultCode == 100) {
						this.$alertify.success('Bag Invalidated Successfully');
						this.resetForm();
					}


				})
				.catch((httpException) => {
					console.error('exception is:::::::::', httpException)
				})
		},

		//to reset search form
		resetForm() {

			this.bagno = '';
			this.bagstatus = '';
			//document.getElementById("groupName").value = "";

			this.bagStatusObjData = {
				value: "",
				text: ""
			};

			//console.log(this.modeObjData);
			this.$validator.reset();

		},

		//validate all form fields on onsubmit()
		onSubmit: function(formname) {
			this.$validator.validateAll().then((formResult) => {
					if (formResult == false) {
						this.validateFlag = false
					} else {
						this.validateFlag = true;
						this.markBagInvalid();
					}
					console.log('form is valid')
				})
				.catch(() => {
					console.log('errors exist')
				});
		},

	}
}



// WEBPACK FOOTER //
// ./src/views/components/MarkBagInvalid/MarkBagInvalid_component.js